export default "__VITE_ASSET__ChvW5_4z__"